export enum GradualRangeEnum {
  Day = 1,
  Week = 7,
  Staff = 29,
  Month = 30
}
